import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TradeFilter } from "../../trading/trades/types";
import { MonthlyTradingReportFilter } from "./types";
import { PageIndex } from "../../models";

type TradesReportState = {
  filter: MonthlyTradingReportFilter;
  index: PageIndex;
};

export const initialState: TradesReportState = {
  filter: {
    numofmonths: 12,
  },
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
};

const name = "monthlyTrade";

const monthlyTrade = createSlice({
  name,
  initialState,
  reducers: {
    setIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    setReportData: (state, action: PayloadAction<number>) => ({
      ...state,
      filter: {
        numofmonths: action.payload,
      },
    }),
    setReportMonth: (state, action: PayloadAction<number>) => ({
      ...state,
      filter: {
        ...state.filter,
        month: action.payload,
      },
    }),
    setReportYear: (state, action: PayloadAction<number>) => ({
      ...state,
      filter: {
        ...state.filter,
        year: action.payload,
      },
    }),
    setFilter: (state, action: PayloadAction<number>) => ({
      ...state,
      filter: {
        ...state.filter,
        numofmonths: action.payload,
      },
    }),
    removeFilter: (state, action: PayloadAction<keyof TradeFilter>) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
  },
});

export const {
  setReportData,
  setReportMonth,
  setReportYear,
  setFilter,
  removeFilter,
  setIndex,
} = monthlyTrade.actions;

export default monthlyTrade.reducer;
